import React from 'react';
import {Paper} from 'material-ui';

export const TabContainer = (props) => {
    return (
        <Paper elevation={2} style={{padding: 10}}>
            {props.children}
        </Paper>
    )
}


// WEBPACK FOOTER //
// ./src/components/tab/tab_container.js